export const TOP_BAR_LOAD = 'TOP_BAR_LOAD';
export const TOP_BAR_LOAD_SUCCESS = 'TOP_BAR_LOAD_SUCCESS';
export const TOP_BAR_LOAD_FAIL = 'TOP_BAR_LOAD_FAIL';